
import OrderReorderRow from '@marketplace/components/account/orders/order-reorder-row.vue'
import Confirmer from '@marketplace/components/forms/confirmer/confirmer.vue'
import Checkbox from '@marketplace/components/forms/inputs/checkbox.vue'
import Loader from '@marketplace/components/shared/loaders/loader.vue'
import {
    DOWNLOAD_IMAGES_MUTATION,
    GET_ORDER_PRODUCTS_BY_ID_QUERY,
} from '@marketplace/graphql/orders.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalDownloadPhotos',
    components: {
        Confirmer,
        Loader,
        Checkbox,
        OrderReorderRow,
    },

    props: {
        orderId: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isAllSelectedState: false,
            isButtonLoading: true,
            isLoading: true,
            isConfirmed: false,
            isbusyConfirming: false,
            message: '',
            productsList: [],
        }
    },

    apollo: {
        order: {
            query: GET_ORDER_PRODUCTS_BY_ID_QUERY,
            variables() {
                return { id: this.orderId }
            },
            result({ data }) {
                this.isLoading = this.isButtonLoading = false

                if (!data) {
                    return
                }

                const orderData = data?.order?.supplierOrders?.edges
                const productsArray = []

                orderData.forEach((order) =>
                    order.node.products.edges.forEach((product) => {
                        productsArray.push({
                            ...product.node,
                            ...{ isSelected: false },
                        })
                    })
                )

                this.productsList = productsArray
            },
        },
    },

    computed: {
        selectedProductsCount() {
            return this.productsList.filter((product) => product.isSelected)
                .length
        },
    },

    methods: {
        toggleSelectAll() {
            this.isAllSelectedState = !this.isAllSelectedState
            this.productsList.forEach((product) =>
                this.$set(product, 'isSelected', this.isAllSelectedState)
            )
        },
        updateSelectedList(payload) {
            this.isAllSelectedState = false

            this.productsList.find((product) => {
                if (product.id === payload.id) {
                    this.$set(product, 'isSelected', payload.value)
                }
            })
        },
        closeModal() {
            EventBus.$emit('modal-close')
        },
        download() {
            this.isButtonLoading = true
            this.isbusyConfirming = true
            this.message = ''

            const itemsToDownload = this.productsList
                .filter((product) => product.isSelected)
                .filter((product) => product.listingVariantId)
                .map((item) => {
                    return {
                        listingVariantId: item.listingVariantId,
                    }
                })

            this.$apollo
                .mutate({
                    mutation: DOWNLOAD_IMAGES_MUTATION,
                    variables: {
                        input: {
                            retailerOrderId: this.orderId,
                            products: itemsToDownload,
                        },
                    },
                })
                .then((response) => {
                    this.message = response.data.productImageExport.products
                    this.isButtonLoading = false
                    this.isConfirmed = true

                    setTimeout(() => {
                        this.closeModal()
                    }, 3000)
                })
        },
    },
}
